import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  Grid,
  Link,
  Button,
  TextField,
  Container,
  Alert,
  Avatar,
  Box,
  Typography,
  InputAdornment,
} from "@mui/material";
import { jwtDecode } from "jwt-decode";

import {
  LockOutlined,
  SettingsRemoteOutlined,
  VisibilityOffOutlined,
  VisibilityOutlined,
} from "@mui/icons-material";
import useStore from "../../store";
import config from "../../config";
import {
  CognitoUser,
  AuthenticationDetails,
  CognitoUserPool,
} from "amazon-cognito-identity-js";
import axios from "axios";
import Profile from "../Profile/Profile";
import Layout from "../Layout/Layout";

let cognitoUser;

export default function Login() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [stage, setStage] = useState(1);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [poolParams, setPoolParams] = useState({});
  const [showPassword, setShowPassword] = useState(false);

  const [loading, setLoading] = useState(false);
  const {
    login,
    tenantId,
    setTenantId,
    error,
    setError,
    setUser,
    setRole,
    isLoggedIn,
  } = useStore((state) => state);
  const idToken = searchParams.get("id_token")
  const accessToken = searchParams.get("access_token")
console.log(isLoggedIn)
  useEffect(() => {
    if (isLoggedIn) {
      navigate("/profile");
    }
    setError("");
    setLoading(false);
  }, [setError, stage, tenantId, isLoggedIn, navigate]);

  useEffect(() => {
    const parentUrl = document.referrer;
    const tenant = parentUrl.includes("ipsznc")
      ? "IPSZNC"
      : parentUrl.includes("ipsmansoura")
        ? "IPSMansoura"
        : "azharengineering2020";
    setTenantId(tenant);

    if (tenantId) {
      localStorage.setItem("tenantId", tenantId);
      setLoading(true);

      setError("");
      axios
        .get(`${config[tenantId].tenantsURL}/tenant_id/${tenantId}`)
        .then(async (response) => {
          const tenant = response.data.tenant;
          const poolId = tenant?.issuer.split("/")[3];
          const clientId = tenant?.app_client_id;
          setPoolParams({ UserPoolId: poolId, ClientId: clientId });
          if (accessToken && idToken) {
            try {
              // Decode and verify tokens using jwt-decode
              const decodedIdToken = jwtDecode(idToken);
              console.log({decodedIdToken})
              localStorage.setItem(`CognitoIdentityServiceProvider.${decodedIdToken.aud}.${decodedIdToken['cognito:username']}.idToken`, idToken)
              localStorage.setItem(`id_token`, idToken)

              localStorage.setItem(`CognitoIdentityServiceProvider.${decodedIdToken.aud}.${decodedIdToken['cognito:username']}.accessToken`, accessToken)
              localStorage.setItem(`CognitoIdentityServiceProvider.${decodedIdToken.aud}.${decodedIdToken['cognito:username']}.LastAuthUser`, decodedIdToken['cognito:username'])
            //  localStorage.setItem(`CognitoIdentityServiceProvider.${decodedIdToken.aud}.${decodedIdToken['cognito:username']}.clockDrift`, 0)

              const usernameFromToken = decodedIdToken['cognito:username'];
              if (usernameFromToken) {
                // Attempt to authenticate using Cognito's session API
                const Pool = new CognitoUserPool({ UserPoolId: poolId, ClientId: clientId });
             //   console.log(Pool.storage)

                // if (Pool.storage) {
                //   const keys = Object.keys(Pool.storage)
                //   for await (let item of keys) {
                //    // console.log(item, Pool.storage[item])
                //     localStorage.setItem(item, Pool.storage[item])
                //   }
                // } 
                cognitoUser = new CognitoUser({ Username: usernameFromToken, Pool });
                localStorage.setItem(`CognitoIdentityServiceProvider.${decodedIdToken.aud}.${decodedIdToken['cognito:username']}.clockDrift`, Pool.storage[`CognitoIdentityServiceProvider.${decodedIdToken.aud}.${decodedIdToken['cognito:username']}.clockDrift`])
                localStorage.setItem(`AnswerID`, Pool.storage['AnswerID'])
                console.log({cognitoUser})
                cognitoUser.getSession((err, session) => {
                  if (err) {
                    console.log({err})
                    setLoading(false);
                    setError("Invalid session");
                  } else {
                    cognitoUser.getUserAttributes((err, attributes) => {
                      if (err) {
                        setLoading(false);
                        setError("Error fetching user attributes");
                      } else {
                        login(session, attributes);
                        console.log({attributes})
                        setUser(attributes);
                        // set refresh token
                        console.log({session})
                        setRole(session);
                        navigate("/profile");
                        setLoading(false);
                      }
                    });
                  }
                });
              }
            } catch (error) {
              setLoading(false);
              setError("Invalid tokens");
            }
          } else setLoading(false);
        });
    } else {
      setLoading(false);
      setError("There is no tenant provided");
    }
  }, [searchParams, setError, setPoolParams, setTenantId, tenantId]);


  useEffect(() => {
    // If access_token and id_token are provided, attempt to validate them

  }, [accessToken, idToken, poolParams, login, setUser, setRole, navigate, setError]);



  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);

    if (username === "" || password === "") {
      setError("* Fields are required");
      setLoading(false);
      return;
    }
    if (poolParams.UserPoolId && poolParams.ClientId) {
      const Pool = new CognitoUserPool(poolParams);
      cognitoUser = new CognitoUser({ Username: username, Pool });

      const authDetails = new AuthenticationDetails({
        Username: username,
        Password: password,
      });

      cognitoUser.authenticateUser(authDetails, {
        onSuccess: (data) => {
          cognitoUser.getUserAttributes((err, attributes) => {
            if (err) {
            } else {
              login(data, attributes);
              setUser(attributes);
              setRole(data);
              navigate("/profile");
            }
          });

          // setStage(2);
          setLoading(false);
        },
        onFailure: (err) => {
          setStage(1);
          setLoading(false);
          setError(err.message);
        },
        newPasswordRequired: (userAttributes, requiredAttributes) => {
          setStage(3);
          setError("");
          setLoading(false);
          delete userAttributes.email_verified;
        },
      });
    } else {
      setError(`Tenant ${tenantId} not found`);
    }
  };

  const handleNewPassword = (event, newPassword) => {
    event.preventDefault();
    cognitoUser.completeNewPasswordChallenge(newPassword, null, {
      onSuccess: (data) => {
        setStage(1);
        setLoading(false);
      },
      onFailure: (err) => {
        setError(err.message);
        setLoading(false);
      },
    });
  };

  return (
    <>
      {stage === 1 && !isLoggedIn && (
        <>
          <Container component="main" maxWidth="xs">
            <Box
              sx={{
                marginTop: 8,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
                <LockOutlined />
              </Avatar>
              <Typography component="h1" variant="h5">
                Login
              </Typography>
              {error && (
                <Alert sx={{ width: "100%" }} severity="error">
                  {error}
                </Alert>
              )}
              <Box
                component="form"
                onSubmit={handleSubmit}
                noValidate
                autoComplete="off"
                sx={{ mt: 1 }}
              >
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="username"
                  label="Username"
                  name="username"
                  autoFocus
                  value={username}
                  onChange={(event) => setUsername(event.target.value)}
                />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type={showPassword ? "text" : "password"}
                  id="password"
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment
                        position="end"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? (
                          <VisibilityOutlined />
                        ) : (
                          <VisibilityOffOutlined />
                        )}
                      </InputAdornment>
                    ),
                  }}
                />
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, mb: 2 }}
                >
                  {loading && (
                    <span className="spinner-border spinner-border-sm"></span>
                  )}
                  Login
                </Button>
                <Grid container>
                  <Grid item xs>
                    <Link
                      href={`forgot-password/?tenantId=${tenantId}`}
                      variant="body2"
                    >
                      Forgot password?
                    </Link>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Container>
        </>
      )}
      {stage === 3 && (
        <>
          <Container component="main" maxWidth="xs">
            <Box
              sx={{
                marginTop: 8,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
                <LockOutlined />
              </Avatar>
              <Typography component="h1" variant="h5">
                Set New Password
              </Typography>
              {error && (
                <Alert sx={{ width: "100%" }} severity="error">
                  {error}
                </Alert>
              )}
              <Box
                component="form"
                width={396}
                onSubmit={(event) => handleNewPassword(event, newPassword)}
                noValidate
                sx={{ mt: 1 }}
              >
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="newPassword"
                  label="Password"
                  type="password"
                  id="newPassword"
                  value={newPassword}
                  onChange={(event) => setNewPassword(event.target.value)}
                />
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, mb: 2 }}
                >
                  Submit
                </Button>
              </Box>
            </Box>
          </Container>
        </>
      )}
    </>
  );
}
